
import { Component, Vue, Watch } from 'vue-property-decorator';
import VWrapper from '@/components/shared/VWrapper.vue';
import { UpsellType } from '@/enums/UpsellType';
import UpgradeUpsell from '@/views/upsell/UpgradeUpsell.vue';
import GoalUpsell from '@/views/upsell/GoalUpsell.vue';
import AddonUpsell from '@/views/upsell/AddonUpsell.vue';

@Component({
  components: { AddonUpsell, GoalUpsell, UpgradeUpsell, VWrapper },
})
export default class Upsell extends Vue {
  activeTab: UpsellType = UpsellType.ADDON;
}
